import getNodePlanData from './getNodePlanData';
import { removePrefix, calculateBasePrice, addT1TactOfferPromo, } from './helperFunctions';
import AppState from "../AppState";
/**
 * Add upgrade options if available at address.
 *
 * @param {AvailableSelections} availablePlan - The available plan for upgrade.
 * @param {AvailableSelections} selectedPlan - The selected plan for upgrade.
 * @returns {object} - The plan upgrade information.
 */
const addPlanUpgrade = (availablePlan, selectedPlan) => {
    var _a, _b;
    const basePrice = calculateBasePrice(selectedPlan);
    const price = basePrice + availablePlan.OptionFee;
    const name = removePrefix(availablePlan.PlanName, 'Speed Boost - ');
    const planType = AppState.get('planType');
    const nodeData = getNodePlanData(availablePlan.PlanIdentifier, planType);
    const discountArray = (availablePlan === null || availablePlan === void 0 ? void 0 : availablePlan.ProductDescriptions) || [];
    const discountText = ((_a = discountArray[0]) === null || _a === void 0 ? void 0 : _a.Text) || '';
    const discountLabel = ((_b = discountArray[0]) === null || _b === void 0 ? void 0 : _b.Label) || '';
    const discountAmount = discountText !== '' ? Number(discountText) : 0;
    addT1TactOfferPromo(availablePlan);
    if (availablePlan.showSpeedUpgrade || availablePlan.showFibreUpgrade) {
        return {
            PlanIdentifier: availablePlan.PlanIdentifier,
            name: name,
            price: price,
            nodeData: nodeData,
            discount: {
                discountAmount: discountAmount,
                discountPrice: discountAmount !== 0 ? price - discountAmount : 0,
                discountType: discountLabel,
            },
            showSpeedUpgrade: false,
            showFibreUpgrade: availablePlan.showFibreUpgrade,
        };
    }
    return {
        PlanIdentifier: availablePlan.PlanIdentifier,
        name: name,
        price: price,
        nodeData: nodeData,
        discount: {
            discountAmount: discountAmount,
            discountPrice: discountAmount !== 0 ? price - discountAmount : 0,
            discountType: discountLabel,
        },
        showSpeedUpgrade: false,
        showFibreUpgrade: false,
    };
};
export default addPlanUpgrade;
